import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ProgressBase  from '@project/guest/contents/influencer_check/parts/progress-base';
import ProgressSpace from '@project/guest/contents/influencer_check/parts/progress-space';
import ProgressCard  from '@project/guest/contents/influencer_check/parts/progress-card';

import Sortable      from 'react-sortablejs';
import ContentsModal from 'contents_modal';
import SubLoading    from 'sub_loading';
// -------------------------------------------------------

class Summary extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    let data      = this.props.data;
    let workflow  = data.workflow || {};
    let influencers = workflow.influencers || {};

    let targets = [];
    for( let i in influencers ){
      let d = influencers[i];
      if( d.status.is_client_check == 1 && d.status.is_client_check_complete == 0 ) targets.push(d);
    }
    
    let base_targets = targets.concat();
    
    this.state = {
      is_active    : false,
      targets      : targets,
      base_targets : base_targets,
      ng_list      : [],
      ok_list      : [],
      modal        : false,
      loading      : false,
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
  }
  // -------------------------------------------------------
  
  change(list, mode) {
    let data = this.props.data;
    let influencer_map = (data.workflow || {}).influencers || {};

    let influencers = [];
    for( let i in influencer_map ){
      if( list.indexOf(i) >= 0 ) influencers.push(influencer_map[i]);
    }
    
    if( mode == 'ng_list' ) this.setState({ ng_list: influencers });
    if( mode == 'targets' ) this.setState({ targets: influencers });
    if( mode == 'ok_list' ) this.setState({ ok_list: influencers });
    
    setTimeout( function(){
      if( this.state.ng_list.length > 0 || this.state.ok_list.length > 0 ) this.setState({ is_active: true });
    }.bind(this), 150);
    
  }
  // -------------------------------------------------------
  
  submit() {
    let chk = confirm('候補者の振り分けを確定してもよろしいですか？');
    if( chk == false ) return;
    
    let ok_list = [];
    let ng_list = [];
    
    this.state.ok_list.map((d) => { ok_list.push(d.insta_user_id); });
    this.state.ng_list.map((d) => { ng_list.push(d.insta_user_id); });

    this.setState({ loading: true });

    // データ通信
    Utils.request.bind(this)('/api/project/workflow/set_influencer_check', { project_id: this.props.data.project.id, ng_list: ng_list, ok_list: ok_list },
      function(res){
        alert('振り分けが完了しました！');
        location.reload();
      }.bind(this),
      function(res){
        alert((res && res.body && res.body.msg) ? res.body.msg : 'エラーが発生しました');
        this.setState({ loading: false });
      }.bind(this)
    );

  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let workflow = data.workflow || {};
    let influencer_map = workflow.influencers || {};

    let progress = [
      { id: 'ng_list', name: 'NG対象', mode: 'normal', icon: 'cancel',       list: this.state.ng_list },
      { id: 'targets', name: '候補者', mode: 'base',   icon: 'groups',       list: this.state.targets },
      { id: 'ok_list', name: 'OK対象', mode: 'normal', icon: 'check_circle', list: this.state.ok_list },
    ];

    let full_accounts = [];
    for( let i in influencer_map ){
      let d = influencer_map[i];
      if( d.status.is_client_check_complete == 1 ) full_accounts.push(d);
    }
    
    return (
      <div className="project-influencer-check">

        <SubLoading flg={this.state.loading} />

        { ((this.state.targets.length + this.state.ok_list.length + this.state.ng_list.length) > 0 )
          ? <div className="influencer-check-contents">
              
              <p className="history-button" onClick={this.toggleModal.bind(this, true)}><i className="material-icons">history</i>履歴を見る</p>
              
              <h2>候補者をご確認の上、「OK」「NG」の選択をお願いします。</h2>
              <h5>（ドラッグ&ドロップで移動できます）</h5>
              
              <div className="progress-contents">
                { progress.map((d, key) => {
                  if( d.mode == 'base' ){
                    return <ProgressBase key={key} base={data} data={d} base_targets={this.state.base_targets} ok_list={this.state.ok_list} ng_list={this.state.ng_list} change_ev={(items) => { this.change.bind(this)(items, d.id) }} />
                  } else {
                    return <ProgressSpace key={key} base={data} data={d} change_ev={(items) => { this.change.bind(this)(items, d.id) }} />
                  }
                })}
              </div>
              
              <i className="material-icons icon-back">arrow_back</i>
              <i className="material-icons icon-forward">arrow_forward</i>
              
              <div className="button" onClick={this.submit.bind(this)}>変更を送信</div>
              
            </div>
          : <div className="influencer-check-contents">
              
              <p className="history-button" onClick={this.toggleModal.bind(this, true)}><i className="material-icons">history</i>履歴を見る</p>
              <h2 className="none-influencer">確認が必要な候補者がいません</h2>
              
            </div>
        }
        
        <InfluencerCheckModal data={data} view={this.state.modal} close_ev={this.toggleModal.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class InfluencerCheckModal extends React.Component {
  render() {
    let data = this.props.data;
    let workflow = data.workflow || {};
    let influencer_map = workflow.influencers || {};

    let ng_list = {};
    let ok_list = {};

    let full_accounts = [];
    for( let i in influencer_map ){
      let d = influencer_map[i];
      if( d.status.is_client_check_complete == 1 ){
        let date = Moment(d.status.client_chek_date).format('YYYY年M月D日 HH時');
        if( d.status.client_chek_date == undefined || d.status.client_chek_date == null ) date = null;
        
        if( d.is_ng == 1 ){
          if( ng_list[date] == undefined ) ng_list[date] = [];
          ng_list[date].push(d);
        } else if( d.status.is_client_check == 1 ){
          if( ok_list[date] == undefined ) ok_list[date] = [];
          ok_list[date].push(d);
        }
      }
    }
    
    // リスト生成
    let ng_list_ary = [];
    let ok_list_ary = [];
    
    for( let i in ng_list ) ng_list_ary.push({ date: i, list: ng_list[i] });
    for( let i in ok_list ) ok_list_ary.push({ date: i, list: ok_list[i] });
    
    ng_list_ary = Utils.sort(ng_list_ary, 'date');
    ok_list_ary = Utils.sort(ok_list_ary, 'date');
    
    let progress = [
      { id: 'ng_list', name: 'NG対象', icon: 'cancel',       list: ng_list_ary },
      { id: 'ok_list', name: 'OK対象', icon: 'check_circle', list: ok_list_ary },
    ];
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {'calc(100% - 150px)'}
        height    = {'500px'}
        max_width = {700}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {(
          <div className="influencer-check-contents-modal">
            
            <div className="progress-contents">
              { progress.map((d, key) => {
                return (
                  <div key={key} className={'progress-space '+ d.id}>
                    <h2><i className="material-icons">{d.icon}</i>{d.name} ({d.list.length}<span>人</span>)</h2>
                    <ul className="progress-scroll">
                      {d.list.map((p, pkey) => {
                        return (
                          <div key={pkey} className="progress-scroll-second">
                            <h4>{(p.date == 'null') ? '未分類' : p.date}</h4>
                            
                            <ul className="progress-scroll-second-list">
                              {p.list.map((f, fkey) => {
                                return <ProgressCard key={fkey} data={f} base={data} />;
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
            
          </div>
        )}
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Summary;